

const initialState = {
  number:0
}

const toDo_Reducer = (state=initialState, action)  =>{
    switch(action.type){
        
        default:
        return state
    }

}


export default toDo_Reducer